/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 50 to 75: ((75 − 50) ÷ 50) × 100 = 50% increase.`)
};

const es_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 50 a 75: ((75 − 50) ÷ 50) × 100 = 50% de aumento.`)
};

const de_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 50 auf 75: ((75 − 50) ÷ 50) × 100 = 50 % Anstieg.`)
};

const nl_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 50 naar 75: ((75 − 50) ÷ 50) × 100 = 50% stijging.`)
};

const fr_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 50 à 75 : ((75 − 50) ÷ 50) × 100 = augmentation de 50 %.`)
};

const it_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 50 a 75: ((75 − 50) ÷ 50) × 100 = aumento del 50%.`)
};

const pt_br2_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 50 para 75: ((75 − 50) ÷ 50) × 100 = 50% de aumento.`)
};

const pt_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 50 para 75: ((75 − 50) ÷ 50) × 100 = 50% de aumento.`)
};

const ja_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50から75へ: ((75 − 50) ÷ 50) × 100 = 50%増加。`)
};

const zh_pct_increase_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 50 到 75：((75 − 50) ÷ 50) × 100 = 增长 50%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_ex2", locale)
	if (locale === "en") return en_pct_increase_ex2(inputs)
	if (locale === "es") return es_pct_increase_ex2(inputs)
	if (locale === "de") return de_pct_increase_ex2(inputs)
	if (locale === "nl") return nl_pct_increase_ex2(inputs)
	if (locale === "fr") return fr_pct_increase_ex2(inputs)
	if (locale === "it") return it_pct_increase_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_ex2(inputs)
	if (locale === "pt") return pt_pct_increase_ex2(inputs)
	if (locale === "ja") return ja_pct_increase_ex2(inputs)
	return zh_pct_increase_ex2(inputs)
};